import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

/* MODELS

Client = {
    "registered": "2018-04-18T12:33:58.719Z",
    "id": 2,
    "email": "email@example.com",
    "name": "Client name"
}

ClientRegister = {
    "email": "email@example.com",
    "name": "Client name"
}

*/


/**
 * Implements Client endpoints from https://github.com/dngroup/msstream-platform/wiki/Upload-Manager-API#client
 */
export default class ClientService {

    /**
     * Get detailed information for client with the given {clientId}. Users can get the information only for the client they belong to.
     * 
     * @param {string} clientId 
     * @param {string} token 
     * @return {Client}
     */
    getClient(clientId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Post a new client
     * 
     * @param {any} data 
     * @param {string} token 
     * @return {Client}
     */
    postClient(data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients`,
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
 * Post a new client
 * 
 * @param {any} data 
 * @param {string} token 
 * @return {Client}
 */
    deleteClientData(clientId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/` + clientId + '/data',
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    cancelDeletionClientData(clientId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/` + clientId + '/data',
                method: 'patch',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Modify the information for client with the given {clientId}. Users can modify the information only if they belong to the given client.
     * 
     * @param {ClientRegister} client
     * @param {string} clientId 
     * @param {string} token 
     * @return {Client}
     */
    putMyClient(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientContract(clientId, isContractSigned, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/contract`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: {
                    isContractSigned
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientRIB(clientId, isRIB, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/rib`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: {
                    isRIB
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientAdmin(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clientsadmin/${clientId}`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientAuthorizedVideos(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/authorizedvideos`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientAuthorizedIPs(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/authorizedips`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientUnauthorizedIPs(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/unauthorizedips`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientUnauthorizedVPNs(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/authorizedvpns`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientAuthorizedVPNsList(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/authorizedvpnslist`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientAuthorizedCountries(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/authorizedcountries`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientUnauthorizedCountries(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/unauthorizedcountries`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getClientAuthorizations(clientId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/authorizations`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getClientStreamKeys(clientId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/streamkeys`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Delete the client with the given {clientId}. 
     * Only the "Administrator" user is allowed to do it. 
     * When a client is deleted all related users, categories, videos and streams will be deleted. 
     * Any ongoing video encoding must be stopped before deleting the client.
     * 
     * @param {string} clientId
     * @param {string} token
     * @return {}
     */
    deleteClient(clientId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getClientIce(clientId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/ices`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    getClientIceClient(clientId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/ices/client`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token,
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    putClientIce(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/ices`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    postClientIce(clientId, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/clients/${clientId}/ices`,
                method: 'post',
                headers: {
                    'Authorization': 'Basic ' + token,
                    'Content-Type': 'application/json',
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

}